import * as React from "react";
import { useState, useEffect } from "react";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Link } from "react-router-dom";
const Qna = () => {
  const [RowData, setRowData] = useState([]);
  const [isLoading, setLoading] = useState(false);

  const columns = [
    { field: "qna_id", headerName: "ID", width: 70 },
    {
      field: "qna_name",
      headerName: "İsim",
      width: 170,
      renderCell: (params) => (
        <Link to={`/qna/${params.id}`}>{params.value}</Link>
      ),
    },
    {
      field: "qna_title",
      headerName: "Konu",
      width: 300,
      renderCell: (params) => (
        <Link to={`/qna/${params.id}`}>{params.value}</Link>
      ),
    },
    {
      field: "qna_text",
      headerName: "içerik",
      width: 700,
      renderCell: (params) => (
        <Link to={`/qna/${params.id}`}>{params.value}</Link>
      ),
    },
    {
      field: "qna_status",
      headerName: "Cevaplandı mı",
      width: 30,
      renderCell: (params) => (
        params.row.qna_verify === 1 ? "yes" : "no"
      ),
    },
  ];
  useEffect(() => {
    fetch(process.env.REACT_APP_DEF_URL + "qnadmin")
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setRowData(data);
        console.log(RowData);
        setLoading(true);
      });
  }, []);

  return (
    <div style={{ height: 400, width: "100%" }}>
      {isLoading === true ? (
        <DataGrid
          rows={RowData}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
        />
      ) : (
        ""
      )}
    </div>
  );
};
export default Qna;
